import { Component, OnInit } from '@angular/core';
import { SHARED_IMPORTS } from '../shared/standalone-imports';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: true,
  imports: [...SHARED_IMPORTS],
})
export class FooterComponent implements OnInit {

  constructor() { }

  public ngOnInit(): void {
  }

}
